import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13b655be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history_box" }
const _hoisted_2 = { class: "time_box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_WishLsit = _resolveComponent("WishLsit")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_listEmpty = _resolveComponent("listEmpty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "History View",
      skipPath: "/usercenter"
    }),
    _createVNode(_component_van_list, {
      loading: $setup.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (($setup.loading) = $event)),
      finished: $setup.finished,
      "finished-text": 
        $setup.historyData.list.length == 0 ? '' : 'No more products found～'
      ,
      "loading-text": "loading",
      onLoad: $setup.onLoad
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.historyData.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "date_container",
            key: item.time
          }, [
            _createElementVNode("h4", _hoisted_2, _toDisplayString(item.time), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.record, (item1) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item1.goods_id
              }, [
                _createVNode(_component_WishLsit, {
                  good_objs: item1,
                  onBeforeClose: $setup.beforeClose,
                  cart_list: $setup.cart_list
                }, null, 8, ["good_objs", "onBeforeClose", "cart_list"])
              ]))
            }), 128))
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "finished-text", "onLoad"]),
    (!$setup.loading && $setup.historyData.list.length == 0)
      ? (_openBlock(), _createBlock(_component_listEmpty, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}